export default "__VITE_ASSET__YE7_$as$__"